import { Injectable, Inject, Injector } from '@angular/core';
import { Http, Headers } from '@angular/http';

import * as Constants from '../utils/constants'
import { map, retry, timeout, catchError } from 'rxjs/operators'
import * as Enum from '../utils/enums'
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  // WS_BASE_URL: string

  constructor(private http: Http) {
  }

  /**
   * get location string url
   */
  getLocationOrigin(): string {
    let url = location.origin
    if (url.includes("localhost")) {
      url = Constants.WS_INTERNAL_URL
    }
    return url
  }

  /**
   * HTTP GET
   * @param url 
   * @param payload 
   */
  doGet(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM): Observable<any> {
    let customHeaders = new Headers()
    customHeaders.append('Content-Type', contentType)

    let serviceURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url
    if (payload) {
      serviceURL += "?" + payload
    } else {
      serviceURL = "" + url
    }

    let httpRequest = this.http.get(serviceURL, { headers: customHeaders }).pipe(
      map(response => {
        if (contentType == Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON) {
          return response.json()
        }
        else if (contentType == Enum.CONTENT_TYPE_ENUM.TEXT_PLAIN) {
          return response
        }

      }),
      catchError(this.handleError)
    )

    return httpRequest
  }

  /**
   * 
   * @param url HTTP POST
   * @param payload 
   */
  doPost(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP

    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, JSON.stringify(payload), { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        // retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }

  /**
   * Handle error
   */
  private handleError(error: Response) {
    return throwError(error)
  }


  /**
   * 
   * @param url HTTP POST
   * @param payload 
   */
  doUploadPagamento(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, pagamentoId: string, nomeFile: string): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.PAGAMENTO_ID, pagamentoId)
      customHeaders.append(Constants.NOME_FILE, nomeFile)
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP

    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }

  /**
   * 
   * @param url HTTP POST
   * @param payload 
   */
  doUploadSAL(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, salId: string, nomeFile: string): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.SAL_ID, salId)
      customHeaders.append(Constants.NOME_FILE, nomeFile)
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP

    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }

  /**
   * upload document for stato antimafia
   * @param url 
   * @param payload 
   * @param contentType 
   * @param aziendaId 
   * @param nomeFile 
   * @param statoAntimafia 
   * @param allegatoAntimafiaId 
   */
  doUploadStatoAntimafiaAzienda(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, aziendaId: string, nomeFile: string, statoAntimafia: string, allegatoAntimafiaId: number): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.AZIENDA_ID, aziendaId)
      customHeaders.append(Constants.NOME_FILE, nomeFile)
      customHeaders.append(Constants.STATO_ANTIMAFIA, statoAntimafia)
      customHeaders.append(Constants.ALLEGATO_ID, String(allegatoAntimafiaId))
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP

    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }


  /**
  * 
  * @param url HTTP POST
  * @param payload 
  */
  doUploadDestinatario(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, nomeFile: string, descrizioneAllegato: string, idCommessa: string): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.NOME_FILE, nomeFile)
      customHeaders.append(Constants.DESCRIZIONE_ALLEGATO, descrizioneAllegato)
      customHeaders.append(Constants.ID_COMMESSA, idCommessa)
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP
    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }

  /**
   * 
   * @param url HTTP POST
   * @param payload 
   */
  doUpload(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, nomeFile: string, numAllegato: string, storicoModuloId: string): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.NOME_FILE, nomeFile)
      customHeaders.append(Constants.NUMERO_ALLEGATO, numAllegato)
      customHeaders.append(Constants.STORICOMODULO_ID, storicoModuloId)
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    // Crea la richiesta HTTP
    //console.log("request", payload)

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }


  /**
   * 
   * @param url HTTP POST
   * @param payload 
   */
  doUploadMassivo(url: string, payload: any, contentType: Enum.CONTENT_TYPE_ENUM, nomeFile: string): Observable<any> {
    let customHeaders = new Headers()

    customHeaders.append('Content-Type', contentType)
    //add header params for all request excepted login
    if (url != Constants.URL_LOGIN) {
      customHeaders.append(Constants.LS_USER_GUID, localStorage.getItem(Constants.LS_USER_GUID))
      customHeaders.append(Constants.LS_USER_TYPE, localStorage.getItem(Constants.LS_USER_TYPE))
      customHeaders.append(Constants.LS_USER_ROLE, localStorage.getItem(Constants.LS_USER_ROLE))
      customHeaders.append(Constants.NOME_FILE, nomeFile)
    }
    // Costruisci l'URL
    let completeURL = this.getLocationOrigin() + Constants.WS_BASE_URL + url

    let httpRequest =

      this.http.post(completeURL, payload, { headers: customHeaders }).pipe(
        timeout(Constants.REQUEST_TIMEOUT),
        retry(Constants.REQUEST_RETRIES),
        map(response => response.json()),
        catchError(this.handleError)
      )

    return httpRequest
  }

}
